<template>
  <v-container fluid class="pb-5 px-0">
    <v-container class="py-0">
      <p class="font-italic text-primary font-weight-bold mt-n1 mb-2">
        {{ vacancy.Title }}
      </p>
      <p class="font-italic font-weight-bold mt-n1 mb-2">
        {{ vacancy.DateStart }}
      </p>
      <p class="font-italic  font-weight-bold mt-n1 mb-2">
      {{ vacancy.WorkPlace }}
      </p>
      <VuetifyRender :html="vacancy.MainText"></VuetifyRender>
    </v-container>
  </v-container>
</template>

<script setup>

const props = defineProps({
  vacancy: {
    type: Object,
    default: {},
  },
});

const count = 1;
let template = ``;
</script>